import { Component } from '@angular/core';

@Component({
  selector: 'wlm-velocity-selector',
  templateUrl: './velocity-selector.component.html',
  styleUrls: ['./velocity-selector.component.scss'],
  standalone: false,
})
export class VelocitySelectorComponent {
  speeds: number[] = [0.25, 0.5, 1];
  selectedSpeed: number = 1;

  onSpeedChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    this.selectedSpeed = Number(selectElement.value);
    console.log(`Velocidad seleccionada: x ${this.selectedSpeed}`);
  }
}
